import { FC } from 'react';

import { Heading } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getVariationTitle } from '@telialt/core-eshop/src/product/ProductVariationBadges/getVariationTitle';
import { BadgeBlockTitleProps } from '@telialt/core-eshop/src/product/ProductVariationBadges/model';
import { BadgeBlockOutOfStockLabel } from '@telialt/core-eshop/src/product/ProductVariationBadges/ProductVariationBadges.styles';

import { VariantTitleRow } from './VariantSelector.styles';

export const RetailsVariantBadgeBlockTitle: FC<BadgeBlockTitleProps> = ({ variation }) => {
    const { t } = useTranslations();

    const title = getVariationTitle(variation, t);
    const showOutOfStockLabel = variation?.isOutOfStock;

    if (!title) {
        return null;
    }

    return (
        <VariantTitleRow>
            <Heading tag="h4" variant="subsection-100">
                {title}
            </Heading>
            {showOutOfStockLabel && (
                <BadgeBlockOutOfStockLabel aria-label={t['eshop.product_page.stock_status.out_of_stock']}>
                    {t['eshop.product_page.stock_status.out_of_stock']}
                </BadgeBlockOutOfStockLabel>
            )}
        </VariantTitleRow>
    );
};
